import { Navigate, Outlet, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AppShell from './components/AppShell';
import { AuthProvider, useAuth } from './context/AuthContext';
import { MobileNavProvider } from './context/MobileNavContext';
import { ThemeProvider } from './context/ThemeContext';
import Account from './pages/Account';
import ProgramDetail from './pages/ProgramDetail';
import Programs from './pages/Programs';
import Home from './pages/Home';
import Login from './pages/Login';
import Logout from './pages/Logout';
import RunDetail from './pages/RunDetail';

function FullPageLoading() {
    return (
        <div className="flex min-h-screen items-center justify-center" style={{ color: 'var(--foreground-muted)' }}>
            Loading...
        </div>
    );
}

function AuthenticatedLayout() {
    return (
        <MobileNavProvider>
            <AppShell>
                <Outlet />
            </AppShell>
        </MobileNavProvider>
    );
}

function AppRoutes() {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return <FullPageLoading />;
    }

    return (
        <Routes>
            <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />
            <Route path="/logout" element={<Logout />} />
            {isAuthenticated ? (
                <Route element={<AuthenticatedLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/programs" element={<Programs />} />
                    <Route path="/programs/:key" element={<ProgramDetail />} />
                    <Route path="/runs/:runId" element={<RunDetail />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            ) : (
                <Route path="*" element={<Navigate to="/login" replace />} />
            )}
        </Routes>
    );
}

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <Router>
                    <AppRoutes />
                </Router>
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
